import React from 'react';
import Fade from 'react-reveal/Fade';

import SideBar from './side-bar/SideBar';
import Experience from './experience/Experience';
import './Home.scss';
import Icon from './icon/icon';

function Home() {
    return (
        <div className="home">
            <SideBar />
            <div className="item">
                <h1 id="about"><Icon icon={"about"} color={"#fff"} size={32} />About</h1>
                <p className="about-p">
                    I am a software developer with 10 years of experience, mainly in web development.
                    I am graduated in system analysis and development.
                    I have worked with many softwares fields, e-commerces, factories, television, hospitals, hydroeletric, a public app.
                    I am very versatil and resilient developer who learns very fast and like challenges.
                </p>
                <img className="about-img" alt="about" src="home1.png" />
            </div>
            <Fade bottom>
                <div className="item">
                    <h1 id="experiences"><Icon icon={"suitcase"} color={"#fff"} size={32} />Experiences</h1>
                    <Experience logo="mavtek.png" jobTitle="Techlead frontend" company="Mavtek" technologies="VueJS, JQuery, Javascript (HTML, CSS3), Webpack, NPM, MySQL, Jenkins, AWS" fromDate="04/2019" location="Montreal/CA" />
                    <Experience logo="groupe azur.png" jobTitle="Software Developer" technologies="Angular, Typescript, Javascript (HTML, CSS3), C# (ASP.NET MVC, Silverlight), SQL Server" company="Groupe Azur" fromDate="02/2018" toDate="04/2019" location="Montreal/CA" />
                    <Experience logo="fsdigital.png" jobTitle="System Analyst" company="FSDIGITAL"  technologies="JQuery, Javascript (HTML, CSS3), C# (ASP.NET MVC, Web forms), ASP Classic (Vbscript), SQL Server" fromDate="06/2012" toDate="01/2018" location="Recife/BR" />
                    <Experience logo="avanade.jfif" jobTitle="Senior Software Engineer" company="Avanade" technologies="C# (ASP.NET MVC, Web forms), JQuery, Javascript (HTML, CSS3), SQL Server, Oracle" fromDate="12/2015" toDate="11/2016" location="Recife/BR" />
                    <Experience logo="funcao logo.png" jobTitle="Software Developer" company="Função Informática" technologies="C# (ASP.NET MVC, Web forms), JQuery, Javascript (HTML, CSS3), SQL Server" fromDate="11/2010" toDate="06/2012" location="Recife/BR" />
                </div>
            </Fade>
            <Fade bottom>
                <div className="item">
                    <h1 id="education"><Icon icon={"education"} color={"#fff"} size={32} />Education</h1>
                    <div className="sub-item">
                        <img src="/assets/img/icons/unibratec.png" alt="unibratec" />
                        <div className="details">
                            <h3>Graduated Analysis and System Development</h3>
                            <h4>Unibratec</h4>
                            <h4>2011-2013</h4>
                            <h5>Recife, BR</h5>
                        </div>
                    </div>
                    <div className="sub-item">
                        <img src="/assets/img/icons/unibratec.png" alt="unibratec" />
                        <div className="details">
                            <h3>Technician Web Development</h3>
                            <h4>Unibratec</h4>
                            <h4>2009-2010</h4>
                            <h5>Recife, BR</h5>
                        </div>
                    </div>
                </div>
            </Fade>

            <Fade bottom>
                <div className="item">
                    <h1 id="skills">Skills</h1>
                    <ul>
                        <li>C#</li>
                        <li>SQL Server</li>
                        <li>Angular</li>
                        <li>VueJS</li>
                        <li></li>
                    </ul>
                </div>
            </Fade>
        </div>
    );
}

export default Home;
